// @codekit-prepend 'functions.js'
// @codekit-prepend 'banner.js'
// @codekit-prepend 'parallax.js'
// @codekit-prepend 'blockquote.js'
// @codekit-prepend 'email-subscription.js'
// @codekit-prepend 'election-news.js'

// Initialisation of the Essay, when the DOM is ready
document.addEventListener('DOMContentLoaded', function(){

	// Banner
	window.addEventListener('load', bannerSetup);
	window.addEventListener('scroll', bannerScroll);

	// Email Newsletter
	window.addEventListener('load', emailSetup);
	window.addEventListener('scroll', emailForm);

	// Interactives on the page
	window.addEventListener('load', electionNews);

	// Blockquotes
	if(window.innerWidth > 600){
		window.addEventListener('load', blockquoteSetup);
		window.addEventListener('load', blockquote);
		window.addEventListener('scroll', blockquote);
	}

	// Parallax
	if(window.innerWidth > 1000){
		window.addEventListener('load', parallax);
		window.addEventListener('scroll', parallax);
	}

	const printButton = document.querySelector('a[title="Print"]');
	printButton.style.display = 'block';
	printButton.addEventListener('click', function(){
		window.print();
	}, false);

}, false); // end of Essay
